import React from 'react'

const Footer = () => {
  return (
    <footer>
          <div
    className="w3-light-grey w3-container w3-padding-32"
    style={{ marginTop: 75, paddingRight: 58 }}
  >
    <p className="w3-right">
      Powered by{" "}
      <a
        href="https://www.w3schools.com/w3css/default.asp"
        title="W3.CSS"
        target="_blank"
        className="w3-hover-opacity"
      >
        w3.css
      </a>
    </p>
  </div>
    </footer>
  )
}

export default Footer